import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Progress } from '../ui/progress';
import { Badge } from '../ui/badge';
import { Sparkles } from 'lucide-react';

export default function CrackedScorePanel({ cracked, usingMock }) {
  const { score, headline, detail } = cracked;

  return (
    <Card className="border-border/60 shadow-sm overflow-hidden">
      <CardHeader className="pb-2 space-y-0">
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-2">
            <Sparkles className="w-4 h-4 text-primary opacity-80" aria-hidden />
            <CardTitle className="font-serif text-lg font-semibold tracking-tight">
              Cracked Score
            </CardTitle>
          </div>
          {usingMock && (
            <Badge variant="outline" className="text-[10px] font-normal text-muted-foreground">
              Sample data
            </Badge>
          )}
        </div>
      </CardHeader>
      <CardContent className="pt-2">
        <div className="flex flex-wrap items-end gap-x-3 gap-y-1">
          {score != null ? (
            <span
              className="font-serif text-5xl sm:text-6xl tabular-nums text-foreground leading-none tracking-tight"
              aria-label={`Cracked score ${score} out of 100`}
            >
              {score}
            </span>
          ) : (
            <span className="font-serif text-4xl text-muted-foreground leading-none">—</span>
          )}
          {score != null && (
            <span className="text-sm text-muted-foreground pb-1.5 tabular-nums">/ 100</span>
          )}
        </div>
        <p className="text-sm font-medium text-foreground mt-3">{headline}</p>
        <p className="text-xs text-muted-foreground mt-1.5 leading-relaxed">{detail}</p>
        {score != null && (
          <Progress
            value={score}
            className="mt-5 h-1.5 bg-muted"
            aria-hidden
          />
        )}
      </CardContent>
    </Card>
  );
}
